import { useEffect } from "react";
import { useActiveChainId } from "../hooks/useActiveChainId";
import { useChain } from "../hooks/useChain";
import { useChainStore } from "../store/chainStore";

export function ChainBootstrap() {
  const [chainId] = useActiveChainId();
  const query = useChain(chainId);
  const setChain = useChainStore((s) => s.setChain);
  const clearChain = useChainStore((s) => s.clearChain);

  useEffect(() => {
    clearChain();
  }, [chainId, clearChain]);

  useEffect(() => {
    if (chainId == null) return;
    if (query.data && query.data.id === chainId) {
      setChain(query.data);
    }
  }, [chainId, query.data, setChain]);

  return null;
}
